import React, {useState, useEffect} from 'react'
import {Form, FormInput, FormGroup} from 'semantic-ui-react'

export const SubOrden =({options, index, handleChange})=>{
    const [product, setProduct]= useState('')
    const [quantity, setQuantity]=useState(0)
    const [unidades, setUnits]=useState('')
    let enEnvio = 0
    let entregadas = 0
    let status = 'solicitado'
    useEffect(()=>{
        handleChange(index, {product, quantity, unidades, enEnvio, entregadas, status})
    }, [product, quantity, unidades, enEnvio, entregadas, status])
    
    const handleQuantity = (e, {value}) => {
        const inputValue = value
        if (/^\d*\.?\d*$/.test(inputValue)) {
            setQuantity(parseInt(inputValue));
        }
    }
    const productSelected = (e, data) => {
        const selectedProduct = data.options.find(option => option.value === data.value)
        if (!selectedProduct) return
        setProduct(selectedProduct.text)
        setUnits(selectedProduct.unidades)
    }
    return (
        <FormGroup>
            <Form.Dropdown 
                label='Producto'
                placeholder='Producto'
                selection
                search
                options={options}
                onChange={productSelected}
            />
            {product!==''? 
                <FormInput
                    label={unidades}
                    type="number"
                    name='quantity'
                    onChange={handleQuantity}
                    value={quantity}
                    style={{ width: '5em' }}
                />
            :null}
        </FormGroup>
    )
}
